import { invokeCode, listCountDebugCode, selectConfig } from "./common";
import { getDefaultValue } from '@tencent/data-schema-core';
import { getObjectJSONString } from "../utils/code";
import { METHOD_TYPES } from "../../stateCommon/consts";
import { FORM_INFOS } from "../formMethods/formInfos";
import { deleteDbReadonlyFields } from "../../common/dbReadonlyFields";
import { getCgiDefaultParamsValue } from "../../common/schemaUtil";
import getDocLink from "../../../tools/getDocLink";
export const initMethodConfig = {
  id: 'init',
  title: '初始化',
  type: METHOD_TYPES.code,
  autoCatch: true,
  loading: false,
  system: true
};
const getListInitCode = options => {
  const {
    collection,
    isHttp
  } = options;
  const dsQueryLink = getDocLink().DS_QUERY_DOC || '';
  const hasCount = !!collection.cgiInfo.count;
  const code = `
async ( ) => {

  // 设置初始值
  source.page =  1;
  source.size =  20;

  // filter格式 [ { k:'id',o:'=',v:'100068' } ]
  ${dsQueryLink ? `  // 具体参考 ${dsQueryLink}` : ''}
  source.filter = [];

  // sort格式 [ { k:'id',o:'asc'},{ k:'no',o:'desc'} ]
  // o:排序类型 asc(正序) desc(倒序)
  source.sort = [];

  // 调用list方法进行初始请求和写入
  await source.$methods.list();
  ${isHttp ? `${hasCount ? '' : '// '}await source.$methods.count();` : ''}
}
`.trim();
  return {
    args: [],
    code
  };
};
function generateListModelInit(options) {
  const config = selectConfig(options, getListInitCode, FORM_INFOS.list.init, true);
  return {
    ...initMethodConfig,
    ...config,
    debugCode: listCountDebugCode
  };
}
const getRvListInitCode = _options => {
  const dsQueryLink = getDocLink().DS_QUERY_DOC || '';
  const code = `
async ( ) => {

  // 设置初始值
  source.page =  1;
  source.size =  20;

  // filter格式 [ { k:'id',o:'=',v:'100068' } ]
  ${dsQueryLink ? `  // 具体参考 ${dsQueryLink}` : ''}
  source.filter = [];

  // sort格式 [ { k:'id',o:'asc'},{ k:'no',o:'desc'} ]
  // o:排序类型 asc(正序) desc(倒序)
  source.sort = [];

  // 调用listWithStatus方法
  return await source.$methods.listWithStatus();
}
`.trim();
  return code;
};
function generateRvListModelInit(options) {
  return {
    id: 'init',
    title: '初始化',
    code: getRvListInitCode(options),
    autoCatch: true,
    loading: true,
    debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
    type: METHOD_TYPES.code,
    args: [],
    meta: {
      convertible: false,
      tpl: 'list.init'
    }
  };
}
const getRvFormInitCode = _options => `
async () => {
    source.formData = source.formData || {}
    const id =source.formData._id || $query.id
    //  如果url上有id参数就进行查询
    if (id) {
      const { data: formData } = await source.$methods.get(id);
      source.formData = formData
      await source.$methods.publishStatus(id)
  }
}
`.trim();
function generateRvFormModelInit(options) {
  return {
    id: 'init',
    title: '初始化',
    code: getRvFormInitCode(options),
    autoCatch: true,
    loading: true,
    debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
    type: METHOD_TYPES.code,
    args: [],
    meta: {
      convertible: false,
      tpl: 'form.init'
    }
  };
}
const getFormInitCode = options => {
  const {
    collection,
    isHttp
  } = options;
  const entitySchema = collection.entity;
  let setDefaultFromData = '';
  if (entitySchema) {
    const data = getDefaultValue(entitySchema);
    if (!isHttp) {
      // db 需要把一些只读属性删了
      deleteDbReadonlyFields(data);
    }
    setDefaultFromData = `
    // 可以在这里给表单设置初始值
    source.formData =${getObjectJSONString(data)}
  `;
  }
  const code = `
    async () => {

    ${setDefaultFromData}

      // 如果url上有id参数就进行查询
      if($query.id){
        await source.$methods.get($query.id);
      }

    }`;
  return {
    args: [],
    code
  };
};
function generateFormModelInit(options) {
  const config = selectConfig(options, getFormInitCode, FORM_INFOS.form.init, true);
  return {
    ...initMethodConfig,
    ...config,
    debugCode: `${invokeCode}
console.log('formData',source.formData);`
  };
}
const getAnyInitCode = options => {
  const {
    collection
  } = options;
  const cgiInfo = collection.cgiInfo.request;
  const {
    query,
    body
  } = getCgiDefaultParamsValue(collection, 'request');
  const isPost = (cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.type) === 'post';
  const code = `
  async ()=>{

    source.data = {};

    source.query = ${getObjectJSONString(query)};

    ${isPost ? ` source.body = ${getObjectJSONString(body)};` : ''}

    // 调用request接口
    // await source.$methods.request();
  }
  `;
  return {
    args: [],
    code
  };
};
function generateAnyModelInit(options) {
  const config = selectConfig(options, getAnyInitCode, FORM_INFOS.any.init, true);
  return {
    ...initMethodConfig,
    ...config,
    debugCode: `${invokeCode}
console.log('data',source.data);`
  };
}
export function generateInitMethod(options) {
  const {
    stateModel
  } = options;
  const methods = {
    list_JS: generateListModelInit,
    rv_list_JS: generateRvListModelInit,
    rv_form_JS: generateRvFormModelInit,
    form_JS: generateFormModelInit,
    any_JS: generateAnyModelInit
  };
  const method = methods[stateModel];
  if (method) {
    return method(options);
  }
  throw new Error(`找不到${stateModel}对应的代码生成逻辑`);
}
//# sourceMappingURL=init.js.map
